// extracted by mini-css-extract-plugin
module.exports = {"start":"idt-align_start__1q9bl","end":"idt-align_end__gnarw","center":"idt-align_center__1c7uf","stretch":"idt-align_stretch__3zpwl"};